// extracted by mini-css-extract-plugin
module.exports = {"reject-box-popup":"RejectBoxPopup_reject-box-popup__rvaLK","text-area":"RejectBoxPopup_text-area__3E-vU"};